module.exports = __webpack_public_path__ + "static/img/nt4.10cf913.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/nt4.jpg
// module id = Vete
// module chunks = 0